export const PREFERRED_COUNTRIES = ['fr', 'de', 'be', 'es', 'ch', 'it', 'at', 'ie', 'gb'];

export const AVAILABLE_COUNTRY_CODES = ['IT', 'DE', 'ES'];
